import { EditableComponent, ModelProps } from '@adobe/aem-react-editable-components';
import { EnrollmentCardContainerProps } from './EnrollmentCardContainer.types';
import { StyledEnrollmentCardContainerComp } from './EnrollmentCardContainer.styles';

export const EnrollmentCardContainer = (props: {
  isAuthorMode: boolean;
  model: EnrollmentCardContainerProps & ModelProps;
}) => {
  return props.isAuthorMode ? (
    <EditableComponent
      config={{
        emptyLabel: 'enrollmentCard',
        isEmpty: () => false,
        resourceType: 'mi-aem-homepage-spa/components/content/enrollmentCard',
      }}
      {...props}
    >
      <StyledEnrollmentCardContainerComp {...props.model} />
    </EditableComponent>
  ) : (
    <StyledEnrollmentCardContainerComp {...props.model} />
  );
};
